var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRectangle1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "289px",
    height: "409px",
    viewBox: "0 0 289 409",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Rectangle1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.6414984,401.820245 L0.293910309,139.197944 C-0.215800968,135.880235 1.39980185,132.597143 4.33948235,130.976873 L238.548575,1.88732085 C242.418023,-0.245411793 247.283752,1.1624746 249.416485,5.03192313 C249.88053,5.87384606 250.189027,6.79251522 250.327184,7.74387441 L288.571237,271.095815 C289.049568,274.389644 287.438526,277.635522 284.525874,279.246288 L52.420317,407.606199 C48.5538988,409.744421 43.6861766,408.34344 41.5479551,404.477022 C41.0915753,403.651778 40.7846997,402.752341 40.6414984,401.820245 Z",
    id: "Rectangle1",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRectangle1);
export default __webpack_public_path__ + "static/media/Rectangle1.dff60eae0cf56a61865a7bfe188e2c8f.svg";
export { ForwardRef as ReactComponent };